module.exports = __webpack_public_path__ + "img/918272e.jpg";